module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.goods.length > 0) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.goods), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 8,
        "lg": 6
      }
    }, [_c('div', {
      staticClass: "goods"
    }, [_c('div', {
      staticClass: "goods-thumbnail"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail_pic,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-caption"
    }, [_c('div', {
      staticClass: "goods-title"
    }, [_vm._v("\n              " + _vm._s(item.sku_name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "goods-title"
    }, [_vm._v(_vm._s(item.sku_bn))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-remove iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.handleSkuRemove(index)
        }
      }
    })])])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleGoodsDialogShow
    }
  }, [_vm._v("选择商品")])], 1), _vm._v(" "), _c('GoodsSelector', {
    attrs: {
      "single": _vm.singleData,
      "items-visible": _vm.itemVisible,
      "get-status": _vm.setItemStatus,
      "rel-items-ids": _vm.relItems,
      "item-type": _vm.item_type
    },
    on: {
      "chooseStore": _vm.handleGoodsSubmit,
      "closeStoreDialog": _vm.handleGoodsDialogHide
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b8d2f058", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8d2f058"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/function/sharerSkuSelector.vue
// module id = 2915
// module chunks = 0